import React, { useEffect, useRef } from 'react';
import hljs from 'highlight.js/lib/core';
import typescript from 'highlight.js/lib/languages/typescript';
import javascript from 'highlight.js/lib/languages/javascript';
import xml from 'highlight.js/lib/languages/xml';
import 'highlight.js/styles/github.css';
hljs.registerLanguage('ts', typescript);
hljs.registerLanguage('tsx', typescript);
hljs.registerLanguage('typescript', typescript);
hljs.registerLanguage('js', javascript);
hljs.registerLanguage('jsx', javascript);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('html', xml);
hljs.registerLanguage('xml', xml);
export function CodeBlock({ code, language = 'tsx', className = '', githubUrl, }) {
    const codeRef = useRef(null);
    useEffect(() => {
        if (codeRef.current) {
            // Ensure the code element text matches the prop
            codeRef.current.textContent = code;
            hljs.highlightElement(codeRef.current);
        }
    }, [code, language]);
    return (React.createElement("div", { className: `w-full max-w-full min-w-0 ${className}` },
        React.createElement("pre", { className: "w-full max-w-full min-w-0 rounded-lg border border-slate-200 bg-slate-50 overflow-x-auto text-sm leading-relaxed" },
            React.createElement("code", { ref: codeRef, className: `block p-4 language-${language} min-w-0 break-words` })),
        githubUrl ? (React.createElement("div", { className: "flex items-center justify-end mt-2" },
            React.createElement("a", { href: githubUrl, target: "_blank", rel: "noreferrer", className: "inline-flex items-center gap-1.5 text-xs text-slate-600 hover:text-slate-900", title: "Open on GitHub" },
                React.createElement("svg", { viewBox: "0 0 16 16", width: "14", height: "14", "aria-hidden": "true", className: "text-slate-700" },
                    React.createElement("path", { fill: "currentColor", d: "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38\n                0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01\n                1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95\n                0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0\n                1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0\n                3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.19 0 .21.15.46.55.38A8.013\n                8.013 0 0016 8c0-4.42-3.58-8-8-8z" })),
                React.createElement("span", { className: "hover:text-orange-600" }, "Check full code on GitHub")))) : null));
}
export default CodeBlock;
